import PaginacaoListagem from '@/core/store/default/paginacaoListagem'

export default {
	paginacao: PaginacaoListagem(['id'], '5', 'DESC'),
}
